"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ContactActions = require("./ContactActions");
Object.keys(_ContactActions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactActions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactActions[key];
    }
  });
});
var _ContactAvatar = require("./ContactAvatar");
Object.keys(_ContactAvatar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactAvatar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactAvatar[key];
    }
  });
});
var _ContactFeatures = require("./ContactFeatures");
Object.keys(_ContactFeatures).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactFeatures[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactFeatures[key];
    }
  });
});
var _ContactLabels = require("./ContactLabels");
Object.keys(_ContactLabels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ContactLabels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _ContactLabels[key];
    }
  });
});
var _Subcontact = require("./Subcontact");
Object.keys(_Subcontact).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Subcontact[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Subcontact[key];
    }
  });
});